import FilterPresenter from "../../../filter/components/Filter/FilterPresenter";

import ChartPresenter from "./Chart/ChartPresenter";
import ConsumerInfoPresenter from "./ConsumerInfo/ConsumerInfoPresenter";
import CounterDevicenameSelectedPresenter from "./ConsumerInfo/CounterDeviceNameSelectedPresenter";
import LastConsumptionPresenter from "./ConsumerInfo/LastConsumptionPresenter";
import ConsumerRankingPresenter from "./ConsummerRanking/ConsumerRankingPresenter";
import ConsumptionAndIndexChartPresenter from "./ConsumptionAndIndexChart/ConsumptionAndIndexChartPresenter";


const ConsumptionChart = {
    Chart : ChartPresenter,
    TimeWindowFilter : FilterPresenter,
    CounterFilter: ConsumerInfoPresenter,
    CounterSelectedInfo: {
        DeviceName : CounterDevicenameSelectedPresenter,
        LastConsumptionValue : LastConsumptionPresenter
    },
    ConsumptionAndIndexChart: ConsumptionAndIndexChartPresenter,
    ConsummerRanking: ConsumerRankingPresenter
}

export default ConsumptionChart;